export interface InitResult {
  system_info: {
    title: string
  }
  station_list: {
    station_id: string
    name: string
    latitude: string
    longitude: string
    address: string
    field_id: string[]
  }[]
  summary_list: {
    multi_station: {
      title: string
      hour: StationListData
      day: StationListData
      month: StationListData
    }
    single_station: {
      [station_id: string]: {
        hour: {
          field_id: string[]
        }
        day: {
          field_id: string[]
        }
        month: {
          field_id: string[]
        }
        year: {
          field_id: string[]
        }
      }
    }
  }
  field_list: {
    [field_id: string]: {
      name: string
      unit: string
      decimal: number
      type: string
    }
  }
  definition_info: {
    graph: {
      common: {
        list_items: {
          items: {
            title: string
            items: {
              title: string
              items: {
                // interval: number
                summary_list: {
                  // interval: number
                  target: string
                  type: string
                }
                target: string
                title: string
                type: string
                default_select?: boolean
              }[]
              list_type: string
            }[]
            list_type: string
          }[]
        }
      }
      threshold: {
        [type: string]: {
          [field: string]: {
            title: string
            value: number
            unit: string
            color: string
            thickness: number
          }[]
        }
      }
    }
  }
  閾値リスト: {
    設定No: string
    閾値名称: string
  }[]
}

interface StationListData {
  title: string
  header_name: string
  items: {
    station_id: string
    field_id: string[]
    alert_property?: Array<string | null>
  }[]
}

export const XRange = {
  HOUR: 'hour',
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year',
}

export type XRangeType = (typeof XRange)[keyof typeof XRange]

export const GraphColor = ['#D22B4D', '#CF6A3F', '#CECE17', '#3D853A', '#3A8FB2', '#84478D', '#855738', '#34495E']
